module.exports = __webpack_public_path__ + "img/representative-photo.212597b5.png";